const STANDARD_STATE_CODES = new Set(["ACT", "NSW", "NT", "QLD", "SA", "TAS", "VIC", "WA", "NZ"]);

const EMAIL_PATTERN = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}(\.[0-9]{1,3}){3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const WEBSITE_PATTERN = /^(?:www\.)?[\w-]+(?:\.[\w-]+)+(?:[/?#][^\s]*)?$/i;

export function getEntityRequiredFieldMessage(candidate) {
    if (!String(candidate?.origin_entity_id || "").trim()) {
        return "You must enter a entity code.";
    }
    if (!String(candidate?.name || "").trim()) {
        return "You must enter a entity name.";
    }
    if (!String(candidate?.st_state || "").trim()) {
        return "You must enter a state.";
    }
    return "";
}

export function getEntityStateWarning(candidate) {
    const state = String(candidate?.st_state || "").trim().toUpperCase();
    if (state && !STANDARD_STATE_CODES.has(state) && candidate?.search_state == null) {
        return "You have entered a state outside of the standard Australia and NZ states. The record has been saved but finding this entity in other parts of the system will be more difficult.";
    }
    return "";
}

export function validateEntityEmail(value) {
    return !String(value || "").trim() || EMAIL_PATTERN.test(String(value).trim());
}

export function validateEntityWebsite(value) {
    return !String(value || "").trim() || WEBSITE_PATTERN.test(String(value).trim());
}

export function getEntityContactValidationMessage(record) {
    const firstName = String(record?.first_name || "").trim();
    const surname = String(record?.surname || "").trim();
    const email = String(record?.email || "").trim();

    if (!firstName && !surname) {
        return "Enter a firstname or lastname.";
    }
    if (email && !EMAIL_PATTERN.test(email)) {
        return "The email is not a correct format";
    }
    return "";
}